export enum StatusUpload {
  AGUARDANDO_PROCESSAMENTO = 1,
  PROCESSANDO,
  FINALIZADO,
  ARQUIVO_REMOVIDO,
}
